export default {
  fi: {
    VehicleShowScene: {
      emptyRemainder: 'Sinulla ei ole yhtään muistutusta.',
      emptyRemainderAddNew: 'Lisää uusi muistutus tästä.',
      emptyServiceEvent: 'Sinulla ei ole yhtään huoltoa tehtynä.',
      emptyServiceEventAddNew: 'Lisää uusi huolto tästä.',
      vehicleInformation: 'Ajoneuvon tiedot',
      vehicleName: 'Nimi',
      vehicleRegisterNumber: 'Rekisterinumero',
      vehicleVIN: 'Valmistenumero',
      vehicleMileage: 'Kilometrit',
      vehicleRunningHours: 'Käyttötunnit',
      vehicleBrand: 'Merkki',
      vehicleModel: 'Malli',
      vehicleModelYear: 'Vuosimalli',
      vehicleCommissioning: 'Käyttöönotto',
      vehicleWarranty: 'Takuu',
      vehicleType: 'Ajoneuvon tyyppi',
      vehicleDescription: 'Kuvaus',
      reminder: 'Muistutus',
      serviceEvent: 'Huoltotapahtumat',
      showDetails: 'Näytä lisää...',
      hideDetails: 'Piilota...',
      partner: 'Partneri',
      actions: 'Ajoneuvon toiminnot',
      actionServiceCall: 'Huoltokutsu',
      actionPay: 'Osta lisenssi',
      attachmentsTitle: 'Liitetiedostot',
      attachmentsInfo:
        'Voit tallentaa ajoneuvolle esimerkiksi huolto-ohjelman, kuitteja ja laskuja. Ajoneuvolle voi tallentaa enintään kolme liitetiedostoa.',
      attachmentsMaxInfo:
        'Yhden tiedoston maksimikoko on 10 Mt. Sallitut tiedostotyypit: PDF, JPG, PNG.',
      attachmentsMaxReached: 'Olet saavuttanut liitetiedostojen enimmäismäärän (3).',
      attachmentsEmpty: 'Ajoneuvolla ei ole vielä yhtään liitetiedostoa.',
      attachmentsName: 'Liitteen nimi',
      attachmentsCreatedAt: 'Lisäyspäivämäärä',
      attachmentsActions: 'Toiminnot',
      attachmentsOpen: 'Avaa',
      attachmentsDelete: 'Poista',
      attachmentsAddNew: 'Lisää uusi liitetiedosto',
      attachmentsClose: 'Sulje',
      attachmentsLink: 'Liitetiedostot ({{count}})',
      attachmentsDeleteConfirmTitle: 'Poista liitetiedosto',
      attachmentsDeleteConfirmDescription:
        'Haluatko varmasti poistaa tämän liitetiedoston? Toimintoa ei voi perua.',
      attachmentsDeleteConfirm: 'Poista liitetiedosto',
      attachmentsDeleteCancel: 'Peruuta',
      attachmentsDeleteSuccess: 'Liitetiedosto poistettu.',
      attachmentMaxSizeExceeded: 'Tiedoston koko ylittää 10 Mt maksimirajan.',
      attachmentsUploading: 'Liitetiedostoa ladataan...',
      attachmentsOpening: 'Valmistellaan liitteen avaamista...',
      attachmentsOpenNotAuthorized: 'Sinun täytyy olla kirjautunut avataksesi liitetiedoston.',
      attachmentsOpenForbidden: 'Sinulla ei ole oikeuksia avata tätä liitetiedostoa.',
      attachmentsOpenError: 'Liitetiedoston avaamisessa tapahtui virhe.',
    },
  },
};
